import { useState, useCallback } from 'react';

export interface BusinessConfig {
  name: string;
  address: string;
  phone: string;
  nit: string;         // NIT / RUT / identificación fiscal
  slogan: string;
  receiptFooter: string;
  logoUrl: string;     // URL pública o data-URL de la imagen
}

const STORAGE_KEY = 'business_config';

const DEFAULTS: BusinessConfig = {
  name: localStorage.getItem('restaurant_name') || 'Mi Restaurante',
  address: '',
  phone: '',
  nit: '',
  slogan: '',
  receiptFooter: '¡Gracias por su visita! Vuelva pronto.',
  logoUrl: '',
};

function load(): BusinessConfig {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) return { ...DEFAULTS, ...JSON.parse(raw) };
  } catch {
    // ignore
  }
  return DEFAULTS;
}

export function saveBusinessConfig(config: BusinessConfig) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(config));
  // Keep legacy key in sync for backward-compat
  localStorage.setItem('restaurant_name', config.name);
}

export function getBusinessConfig(): BusinessConfig {
  return load();
}

export function useBusinessConfig() {
  const [config, setConfigState] = useState<BusinessConfig>(load);

  const save = useCallback((next: BusinessConfig) => {
    saveBusinessConfig(next);
    setConfigState(next);
  }, []);

  const update = useCallback((patch: Partial<BusinessConfig>) => {
    setConfigState(prev => {
      const next = { ...prev, ...patch };
      saveBusinessConfig(next);
      return next;
    });
  }, []);

  return { config, save, update };
}
